<h2>Search Basic Examples</h2>

<div class="select-grid">
	<div class="select-column">
		<span class="label">Search básico</span>
		<app-search
			[formControl]="searchControl"
			[suggestions]="countrySuggestions"
			placeholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'searchControl', suggestions: 'countrySuggestions', placeholder: 'Buscar países...'})" />
	</div>

	<div class="select-column">
		<span class="label">Search con label</span>
		<app-search
			[formControl]="searchControl"
			[suggestions]="countrySuggestions"
			label="País"
			placeholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'searchControl', suggestions: 'countrySuggestions', label: 'País', placeholder: 'Buscar países...'})" />
	</div>
</div>

<h2>Search Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-search
			[formControl]="searchControl"
			[suggestions]="countrySuggestions"
			label="Large Search"
			size="large"
			placeholder="Large search..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'searchControl', suggestions: 'countrySuggestions', label: 'Large Search', size: 'large', placeholder: 'Large search...'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-search
			[formControl]="searchControl"
			[suggestions]="countrySuggestions"
			label="Medium Search"
			size="medium"
			placeholder="Medium search..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'searchControl', suggestions: 'countrySuggestions', label: 'Medium Search', size: 'medium', placeholder: 'Medium search...'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-search
			[formControl]="searchControl"
			[suggestions]="countrySuggestions"
			label="Small Search"
			size="small"
			placeholder="Small search..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'searchControl', suggestions: 'countrySuggestions', label: 'Small Search', size: 'small', placeholder: 'Small search...'})" />
	</div>
</div>

<h2>Search States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-search
			[formControl]="searchControl"
			[suggestions]="countrySuggestions"
			placeholder="Normal search..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'searchControl', suggestions: 'countrySuggestions', placeholder: 'Normal search...'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-search
			[formControl]="disabledSearchControl"
			[suggestions]="countrySuggestions"
			placeholder="Disabled search..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledSearchControl', suggestions: 'countrySuggestions', placeholder: 'Disabled search...', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-search
			[formControl]="errorSearchControl"
			[suggestions]="countrySuggestions"
			placeholder="Error search..."
			[error]="true"
			errorMessage="Este campo es obligatorio"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'errorSearchControl', suggestions: 'countrySuggestions', placeholder: 'Error search...', error: true, errorMessage: 'Este campo es obligatorio'})" />
	</div>
</div>
